"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispatchUserActionEvent = dispatchUserActionEvent;
var _checkoutUtils = require("@ori/checkout-utils");
var _constants = require("../constants");
/**
 * Triggers user-action event for analytics.
 * @param metaHierarchy Array of predefined items describing current user action.
 */
function dispatchUserActionEvent(metaHierarchy) {
  const dispatchUserAction = (0, _checkoutUtils.getUserActionEventDispatcher)(_constants.PACKAGE_NAME);
  dispatchUserAction(metaHierarchy);
}